import { sendForm } from "@emailjs/browser";

let serviceId = 'service_44oubqm'
let invitationTemplateId = 'template_z9t9lw5'
let signUpConfirmationTemplateId = 'template_kw2o4hy'
let applicationAcceptanceTemplateId = 'template_6pt6ilb'
let userId = 'cXK4yYycQ3zY2Xbbn'

const createInvitationForm = (firstname, email) => {
    var form = document.createElement("form")
    var FN = document.createElement("input");
    var EMAIL = document.createElement("input");

    FN.setAttribute("type", "text");
    FN.setAttribute("name", "firstname");
    FN.value = firstname

    EMAIL.setAttribute("type", "email")
    EMAIL.setAttribute("name", "email")
    EMAIL.value = email

    form.appendChild(FN)
    form.appendChild(EMAIL)

    return form
}

const sendInvitationEmail = (firstname, email) => {
    let htmlForm = createInvitationForm(firstname, email)

    sendForm(serviceId, invitationTemplateId, htmlForm, userId)
        .catch(error => {
            console.log(error)
        })
}

const sendApplicationAcceptance = (firstname, email) => {
    let htmlForm = createInvitationForm(firstname, email)

    sendForm(serviceId, applicationAcceptanceTemplateId, htmlForm, userId)
        .catch(error => {
            console.log(error)
        })
}

const sendSignUpConfirmationEmail = (firstname, email) => {
    let htmlForm = createInvitationForm(firstname, email)

    sendForm(serviceId, signUpConfirmationTemplateId, htmlForm, userId)
        .catch(error => {
            console.log(error)
        })
}

export {
    sendInvitationEmail,
    sendSignUpConfirmationEmail,
    sendApplicationAcceptance
}